var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotRenewed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 6)",
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.21 27.176H1.415A1.416 1.416 0 0 1 0 25.759V1.416C0 .634.634 0 1.416 0H39.21c.783 0 1.417.634 1.417 1.416V25.76c0 .783-.635 1.417-1.417 1.417z",
    fill: "#9AC9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.21 0h-2.64c.783 0 1.417.634 1.417 1.416V25.76c0 .783-.634 1.417-1.417 1.417h2.64c.782 0 1.416-.634 1.416-1.417V1.416C40.626.634 39.99 0 39.209 0z",
    fill: "#6DA4E3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E1929",
    d: "M0 5.834h40.626v3.74H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M37.987 5.834h2.639v3.74h-2.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.251 15.349h-13.44a.692.692 0 1 1 0-1.384h13.44a.692.692 0 1 1 0 1.384zM32.251 19.485h-6.688a.692.692 0 1 1 0-1.384h6.688a.692.692 0 1 1 0 1.384z",
    fill: "#0E1929"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DA2346",
    cx: 36.456,
    cy: 25.73,
    r: 9.377
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.456 16.352c-.458 0-.908.034-1.348.097 4.54.654 8.03 4.56 8.03 9.28 0 4.722-3.49 8.628-8.03 9.281a9.377 9.377 0 1 0 1.348-18.658z",
    fill: "#BA1232"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F9F6F9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.863 29.829a.69.69 0 0 1-.489-.203l-6.815-6.815a.692.692 0 0 1 .978-.978l6.815 6.815a.692.692 0 0 1-.489 1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.048 29.829a.69.69 0 0 1-.489-1.181l6.815-6.815a.692.692 0 0 1 .978.978l-6.814 6.815a.69.69 0 0 1-.49.203z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotRenewed);
export default __webpack_public_path__ + "static/media/not-renewed.7344408c084ad18d995e77d77e95158d.svg";
export { ForwardRef as ReactComponent };